import utils = egr.wcf.utils;

declare global {
    interface Error {
        exOptions?: ErrorContext;
    }
}

export type SentryErrorLevel = 'info' | 'warning' | 'error';
export interface ErrorContext {
    tags?: Array<string>;
    extra?: {[id: string]: any};
    level?: SentryErrorLevel;
}

export abstract class Logging {
    /**
     * This function should be used to provide an more accurate stack trace
     * for erros thrown in the global context
     * (e.g. a thrown in a setTimeout callback)
     */
    public static getError(message: string, context?: ErrorContext): Error {
        try {
            const error: Error = new Error(message);
            if (context != null) {
                error.exOptions = context;
            }

            throw error;
        } catch (error) {
            return error as Error;
        }
    }

    public static warnHook(message: string): void {
        Logging.logHook('warning', message);
    }

    public static errorHook(error: {message: string, error?: any}): void {
        Logging.logHook('error', error.message, error.error);
    }

    public static logHook(level: SentryErrorLevel, message: string, error?: any): void {
        if (error == null) {
            console.error(new Error(message));
        } else {
            console.error(error);
        }
    }
}

utils.Log.eventWarn.addListener(Logging.warnHook as any);
utils.Log.eventError.addListener(Logging.errorHook as any);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/Logging.ts